import React, { Component } from 'react';
import Box from '../ui/Box';
import { Dialog } from 'material-ui';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Select from 'react-select'

import * as config from './SupportedThermostats.json'

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

export default class NewThermostat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brandsList: [],
      selectedBrand: this.props.details && this.props.details.brand ? this.props.details.brand : '',

      modelsList: [],
      selectedModel: this.props.details && this.props.details.model ? this.props.details.model : '',
      showModels: false,

      room_id: this.props.room_main_id ? this.props.room_main_id : '',
      hotel_id: this.props.details && this.props.hotel_id ? this.props.details.hotel_id : ls.getUserDetails().hotel_id ? ls.getUserDetails().hotel_id : null,
      device_id: this.props.details && this.props.details.device_id ? this.props.details.device_id : '',

      name: this.props.details && this.props.details.name ? this.props.details.name : '',

      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  } 

  componentDidMount() {
    this.getBrands();
  }

  getBrands() {
    let brandArray = [];
    for (let thermo in config) {
      if (thermo && thermo != 'default') {
        brandArray.push({
          value: config[thermo].brand,
          label: config[thermo].brand
        });
      }
    }
    this.setState({
      brandsList: brandArray
    });

    if (this.props.details && this.props.details._id) {
      this.getModels();
    }
  }

  getModels() {
    let models = [];
    for (let thermo in config) {
      if (thermo && thermo != 'default') {
        if (config[thermo].brand == this.state.selectedBrand) {
          if (config[thermo].models && config[thermo].models.length) {
            config[thermo].models.forEach((modelPresent) => {
              models.push({
                value: modelPresent.name,
                label: modelPresent.name
              });
            });
          }
        }
      }
    }
    this.setState({
      modelsList: models

    }, () => {
      this.showModels = true
    });
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  createThermoStat(e) {
    e.preventDefault();
    if (
      !this.state.name || !this.state.selectedBrand || !this.state.selectedModel || !this.state.device_id) {
      this.setState({
        dialog: {
          open: true,
          head: 'Invalid',
          body: 'All Fields are mandatory',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      });
      return;
    }
    let payload = {};
    payload = {
      room_id: this.state.room_id,
      hotel_id: this.state.hotel_id,
      model: this.state.selectedModel,
      brand: this.state.selectedBrand,
      name: this.state.name,
      device_id: this.state.device_id
    };

    if (this.props.details) {
      ds.postUpdateThermostat( payload,
        data => {
          let evt = new CustomEvent('updateThermoTable', { detail: true });
          window.dispatchEvent(evt);
          this.props.unMountMe();
        },
        err => {}
      );

    } else {
      ds.postCreateThermostat( payload,
        data => {
          this.setState({
            selectedModel: '',
            selectedBrand: '',
            name: '',
            device_id: '',
            showModels: false
          });
          let evt = new CustomEvent('updateThermoTable', { detail: true });
          window.dispatchEvent(evt);
          this.props.unMountMe();
        },
        err => {}
      );
    }
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  render() {
    return (
      <Box header={this.props.details && this.props.details._id ? 'Edit Thermostat' : 'New Thermostat'}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12">
          <form className="smart-form " onSubmit={this.createThermoStat.bind(this)}>
            <fieldset>
              <section>
                <TextField
                  floatingLabelText="Name"
                  name="name"
                  className="w-100"
                  value={this.state.name}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Device ID"
                  name="device_id"
                  className="w-100"
                  value={this.state.device_id}
                  onChange={this.handleChanges.bind(this)}
                  disabled={this.props.details ? true : false}
                />
              </section>

              <section>
                <Select
                  id="brand"
                  ref={(ref) => { this.select = ref; }}
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  autoFocus
                  options={this.state.brandsList}
                  simpleValue
                  clearable={true}
                  name="selectedBrand"
                  disabled={false}
                  value={this.state.selectedBrand}
                  onChange={(newValue) => {
                    this.setState({
                      selectedBrand: newValue,

                    }, () => {
                      this.getModels();
                    });
                  }}
                  searchable={true}
                  placeholder="Select Brand Name"
                  style={{ marginTop: "15px" }}
                />
              </section>

              {
                this.state.selectedBrand && this.state.selectedBrand != '' ?
                  <section>
                    <Select
                      id="model"
                      ref={(ref) => { this.select3 = ref; }}
                      onBlurResetsInput={false}
                      onSelectResetsInput={false}
                      options={this.state.modelsList}
                      simpleValue
                      clearable={true}
                      name="selectedModel"
                      disabled={false}
                      value={this.state.selectedModel}
                      onChange={(newValue) => {
                        this.setState({
                          selectedModel: newValue,
                        })
                      }}
                      searchable={true}
                      placeholder="Select Model Name"
                      style={{ marginTop: "15px" }}
                    />
                  </section>
                : null
              }
            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label="Save"
                primary
                type="submit"
              />

              <span className="space"></span>

              {
                this.props.details && this.props.details._id ?
                  <FlatButton
                    label="Cancel"
                    primary
                    onClick={this.props.unMountMe.bind(this, false)}
                    type="button"
                  /> 
                : null
              }
            </div>
          </form>
        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/thermostats/NewThermostat.js